import React from 'react'
import CameraSection from '../Home/sub/CameraSection'
import FeatureCardsSection from './sub/FeatureCardsSection'
import SectionTitle from '../../components/SectionTitle/SectionTitle'
import SubAbout from './sub/SubAbout'

export default function About() {
  return (
    <>
    <SectionTitle title="About us" />
     <SubAbout />
     <CameraSection />
     {/* <FeatureCardsSection /> */}
    </>
  )
}
